import {Modal} from "../../../../components/modal/modal.jsx";
import Button from "../../../../components/button/button.jsx";
import React, {useEffect, useState} from "react";
import InputForm from "../../../../components/input/input-form.jsx";
import InputTextarea from "../../../../components/input/input-textarea.jsx";
import projectUtils from "../../../../utils/project-utils.js";
import ocrCamsIntegrationService from "../../../../services/web/ocr-cams-integration-service.js";

const initialState = {lanePrefix: "", properties: {}}

const OcrCamsIntegrationConfig = ({data, open, setOpen, target, options, refetch}) => {
    const [state, setState] = useState(initialState);

    useEffect(() => {
        if (!target) return;

        const find = data.find(item => item.name === target);

        const properties = JSON.stringify(find.properties || {}, null, 2);
        setState({lanePrefix: find.lanePrefix, properties});
    }, [target]);

    const onChange = ({target: {id, value}}) => setState(prev => ({...prev, [id]: value}))

    const save = () => {
        let propertiesJson;

        try {
            propertiesJson = JSON.parse(state.properties);
        } catch (error) {
            projectUtils.swalErrorMessage('', 'O código JSON está inválido.', 'Ok');
            return;
        }

        const integration = options.find(o => o.label === target)?.value;
        if (!integration) {
            projectUtils.swalErrorMessage('', 'Não foi possível prosseguir.', 'Ok');
            return;
        }

        ocrCamsIntegrationService.save(integration,{lanePrefix: state.lanePrefix, properties: propertiesJson})
            .then(() => {
                setOpen(false);
                refetch();
            })
            .catch(error => {
                let message = 'Não foi possível inserir a integração.';
                if (error.response && error.response.status !== 500) {
                    message = error.response.data.message;
                }
                projectUtils.swalErrorMessage('', message, 'Ok');
            })
    }

    return (
        <Modal open={open} setOpen={setOpen} title={target} overflow={true} className={"w-[45rem]"}>
            <Modal.Body className={"space-y-4"}>
                <InputForm
                    id={"lanePrefix"}
                    value={state.lanePrefix}
                    label={"Prefixo"}
                    onChange={onChange}
                />

                <InputTextarea
                    textAreaClass={"min-h-[10rem]"}
                    id={"properties"}
                    value={state.properties}
                    label={"JSON"}
                    onChange={onChange}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={save} actionFeedbackType='save'>

                    Salvar
                </Button>
            </Modal.Footer>
        </Modal>
    )
};

export default OcrCamsIntegrationConfig;